import { render, staticRenderFns } from "./selectScale.vue?vue&type=template&id=a213670a&scoped=true&"
import script from "./selectScale.vue?vue&type=script&lang=js&"
export * from "./selectScale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a213670a",
  null
  
)

export default component.exports